import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getContacts = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/contacts?' + params.toString()); // Let the error bubble up
};

const getContactById = async (id: number) => {
  return await apiClient.get(`/contacts/${id}`); // Fetch car listing by ID
};

const createContact = async (contactData: any) => {
  return await apiClient.post('/contacts', contactData); // Create a new car listing
};

const updateContact = async (id: number, contactData: any) => {
  return await apiClient.patch(`/contacts/${id}`, contactData); // Update car listing by ID
};

const deleteContact = async (id: number) => {
  return await apiClient.delete(`/contacts/${id}`); // Delete car listing by ID
};

const getContactByClientId = async (client_id: number) => {
  return apiClient.get('/contacts?filter[client_id]=' +client_id); // Let the error bubble up
};

const searchContact = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/contacts?' + params.toString()); // Let the error bubble up
};

export default {
  getContacts,
  getContactById,
  createContact,
  updateContact,
  deleteContact,
  getContactByClientId,
  searchContact
};
